// Librerias
import React from 'react'
import api from '../../apiClient/v1'
let PropTypes = React.PropTypes
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
import { ZoomImagen } from '../../components/ZoomImagen/ZoomImagen.jsx'
import { InputRun } from '../../shared/input/InputRun.jsx'
// Notify
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
// Style
import classNames from 'classnames/bind'
import * as css from './modal.css'
let cx = classNames.bind(css)

// function as a children FTW! :D
export class ModalTrigger extends React.Component {
    constructor(props) {
        super(props)
        this.state = { visible: false }
        let self = this
        this.show = () =>
            self.setState({ visible: true })
        this.hide = () => {
            self.setState({ visible: false })
        }
    }
    render() {
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalConfirmar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            usuario: this.props.usuario,
            show: true
        }
        this.editarUsuario = (datos) => {
            let banco = this.props.datosbancos.bancos.find(banco => banco.nombreCorto == datos.banco)
            let tipoCuenta = this.props.datosbancos.tipo_cuentas.find(cuenta => cuenta.nombreCuenta == datos.tipoCuenta)
            datos.banco = banco.idBanco;
            datos.tipoCuenta = tipoCuenta.idCuenta;
            api.usuario(this.state.usuario.id).actualizar(datos)
                .then(resp => {
                    this.props.fetchUsuarios()
                    this.props.hideModal()
                })
                .catch(err => {
                    console.log(err)
                })
        }
        this.confirmar = (datos) => {
            this.props.confirmar(datos)
            this.setState({
                show: false
            })
        }
    }
    render() {
        return (
            <Modal show={this.state.show} onHide={this.props.hideModal} className={cx('modal')} dialogClassName={cx('modalUser')}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmando a operador(a): {this.props.usuario.rowData.nombre1} {this.props.usuario.rowData.apellidoPaterno}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {console.log(this.props.usuario, this.state.usuario)}
                    <div>
                        <b>Nombre: </b>{this.props.usuario.rowData.nombre1} {this.props.usuario.rowData.nombre2} {this.props.usuario.rowData.apellidoPaterno} {this.props.usuario.rowData.apellidoMaterno}< br />
                        <b>RUN: </b>{this.props.usuario.rowData.RUN}
                    </div>
                    <div>
                        <b>Region: </b>{this.props.usuario.rowData.region}< br />
                        <b>Comuna: </b>{this.props.usuario.rowData.comuna}< br />
                        <b>Captador: </b>{this.props.usuario.rowData.captador}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={() => this.confirmar(this.props.usuario.rowData)}>Aceptar</button>
                    <button className="btn btn-danger" onClick={this.props.hideModal}>Cancelar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/OperadoresPendientes/Modales.jsx